import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Grid, Input, Table } from 'semantic-ui-react';
import { EnumEx, EUserGroup, IAssignee, IUser, UserGroupLabels } from '@relab/alstom-ptw-shared';
// @ts-ignore
import CsvDownloader from 'react-csv-downloader';

import { appState } from '../redux/selectors';
import { AssigneeCreateComponent } from './AssigneeCreateComponent';
import { AssigneeDeleteModal } from './AssigneeDeleteModal';
import { RootState } from '../redux/types';
import { TranslationComponent } from './TranslationComponent';
import { useTranslation } from 'react-i18next';

const csvColumns = [
  {
    id: 'name',
    displayName: 'Name',
  },
  {
    id: 'email',
    displayName: 'Email',
  },
  {
    id: 'groupLabel',
    displayName: 'Role',
  },
];

interface PAssigneeComponentProps {
  assignees: IAssignee[];
  projectName: string;
}

const PAssigneeComponent = ({ assignees, projectName }: PAssigneeComponentProps) => {
  const [roleFilter, setRoleFilter] = useState('');

  const { t } = useTranslation();

  const filteredAssignees = assignees.filter((assignee) =>
    UserGroupLabels[EUserGroup[assignee.group]].includes(roleFilter)
  );

  return (
    <Container>
      <AssigneeCreateComponent />

      <Grid columns="equal" style={{ marginTop: 0 }}>
        <Grid.Row>
          <Grid.Column>
            <Input
              list="roles"
              placeholder={t('Choose role...')}
              label={t('Role')}
              onChange={(event, { value }) => setRoleFilter(value)}
            />
            <datalist id="roles">
              {EnumEx.getNames(EUserGroup)
                .map((userGroup) => UserGroupLabels[userGroup])
                .map((roleName, index) => (
                  <option key={index}>{roleName}</option>
                ))}
            </datalist>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <CsvDownloader
              filename={`${projectName}-users-export`}
              separator={';'}
              wrapColumnChar={'"'}
              columns={csvColumns}
              datas={filteredAssignees.map((assignee) => ({
                name: (assignee.user as IUser).name,
                email: (assignee.user as IUser).email,
                groupLabel: UserGroupLabels[EUserGroup[assignee.group]],
              }))}
              prefix={''}
              suffix={''}
            >
              <Button>
                <TranslationComponent stringKey={'Export'} />
              </Button>
            </CsvDownloader>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <TranslationComponent stringKey={'Name'} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <TranslationComponent stringKey={'Email'} />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <TranslationComponent stringKey={'Role'} />
            </Table.HeaderCell>
            <Table.HeaderCell />
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {filteredAssignees.map((assignee) => (
            <Table.Row key={assignee._id}>
              <Table.Cell>{(assignee.user as IUser).name}</Table.Cell>
              <Table.Cell>{(assignee.user as IUser).email}</Table.Cell>
              <Table.Cell>{UserGroupLabels[EUserGroup[assignee.group]]}</Table.Cell>
              <Table.Cell>{<AssigneeDeleteModal assignee={assignee} />}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

const mapStateToProps = (state: RootState) => ({
  assignees: appState(state).project.assignees,
  projectName: appState(state).project.name,
});

export const AssigneeComponent = connect(mapStateToProps)(PAssigneeComponent);
